import { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import ReactSelect from "react-select";
import styled from "styled-components";
//import { EditPencilIcon } from "../../../assets/icons";
import { ArrowDownIcon } from "../../../assets/icons/Icons";
import { General } from "./General";
import {
  GET_SINISTER_BY_CONTRACT,
  GET_SINISTER_BY_ID,
  GET_DOCUMENTARIES_SINESTER,
  GET_REMIDER_SINESTER,
  GET_REMIDER_DOCUMENTS,
} from "../../../services/siniestro";
import { AgregarMovimientos } from "../CapturaSiniestro";
import { useContract } from "../../../redux/contractReducer";
import { useSiniester } from "../../../redux/siniesterReducer";
import { useRef } from "react";

/* const options = [
  { value: "1", label: "#00001" },
  { value: "2", label: "#00002" },
]; */

export const Siniestro = ({
  setIsBlockedSiniester,
  isBlockedSiniester,
  dataSelected,
  siniestroRef,
}) => {
  const [open, setOpen] = useState(false);
  const [openMovements, setOpenMovements] = useState(false);
  const [options, setOptions] = useState([]);
  const [dataSinester, setDataSinester] = useState([]);
  const [dataRemider, setDataRemider] = useState([]);
  const [dataDocumentsSinester, setDataDocumentsSinester] = useState([]);
  const [documentsRemider, setDocumentsRemider] = useState([]);
  const { contractState } = useContract();
  const { setSiniester, resetSiniester, siniesterState } = useSiniester();
  const generalRef = useRef(null);

  const [getAllSinisterByContract] = useLazyQuery(GET_SINISTER_BY_CONTRACT, {
    fetchPolicy: "no-cache",
    onCompleted({ getAllSinisterByContract }) {
      if (getAllSinisterByContract.statusCode === 200) {
        const resultData = JSON.parse(getAllSinisterByContract.response);
        const newResulData = [];
        resultData.length > 0 &&
          resultData.forEach((element) => {
            newResulData.push({
              value: element.siniestro_id,
              label: `#${String(element.siniestro_id).padStart(4, "0")}`,
            });
          });
        setOptions(newResulData);
      }
    },
  });

  const [getDocumentariesByIdSinester] = useLazyQuery(
    GET_DOCUMENTARIES_SINESTER,
    {
      fetchPolicy: "no-cache",
      onCompleted({ getDocumentariesByIdSinester }) {
        if (getDocumentariesByIdSinester.statusCode === 200) {
          const resultData = JSON.parse(getDocumentariesByIdSinester.response);
          setDataDocumentsSinester(resultData);
        }
      },
    }
  );

  const [getAllSinisterById] = useLazyQuery(GET_SINISTER_BY_ID, {
    fetchPolicy: "no-cache",
    onCompleted({ getAllSinisterById }) {
      if (getAllSinisterById.statusCode === 200) {
        const resultData = JSON.parse(getAllSinisterById.response);
        setDataSinester(resultData);
        if (resultData.length > 0) {
          setSiniester(resultData[0]);
          getDocumentariesByIdSinester({
            variables: { idSinester: resultData[0].siniestro_id },
          });
          getAllRemiderByIdSinester({
            variables: { idSinester: resultData[0].siniestro_id },
          });
        }
      }
    },
  });

  const [getDocRemiderByIdRemider] = useLazyQuery(GET_REMIDER_DOCUMENTS, {
    fetchPolicy: "no-cache",
    onCompleted({ getDocRemiderByIdRemider }) {
      if (getDocRemiderByIdRemider.statusCode === 200) {
        const resultData = JSON.parse(getDocRemiderByIdRemider.response);
        setDocumentsRemider(resultData);
      }
    },
  });

  const getRemiderIds = (data) => {
    const ids = data.map((id) => id.recordatorio_id);
    return ids.join();
  };

  const [getAllRemiderByIdSinester] = useLazyQuery(GET_REMIDER_SINESTER, {
    fetchPolicy: "network-only",
    onCompleted({ getAllRemiderByIdSinester }) {
      if (getAllRemiderByIdSinester.statusCode === 200) {
        const resultData = JSON.parse(getAllRemiderByIdSinester.response);
        setDataRemider(resultData);
        const resutlIds = getRemiderIds(resultData);
        resutlIds &&
          getDocRemiderByIdRemider({
            variables: { idRemider: resutlIds },
          });
      }
    },
  });

  const onButton = () => {
    if (dataSinester[0]?.siniestro_id) {
      setIsBlockedSiniester(!isBlockedSiniester);
    }
  };

  const selectedSinester = async (choice) => {
    await resetSiniester();
    choice &&
      (await getAllSinisterById({
        variables: { idSinester: choice.value },
      }));
  };

  useEffect(() => {
    if (siniesterState?.dashboard){
      getAllSinisterById({
        variables: { idSinester: +siniesterState?.siniestro_id },
      });
      setSiniester({dashboard:false, ...siniesterState});
      setOpen(true);
      setIsBlockedSiniester(false);
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
      //wait 2 seconds to scroll
      setTimeout(() => {
      generalRef?.current?.scrollIntoView({ behavior: "smooth" });
      }, 200);
    
  }, [generalRef]);
  useEffect(() => {
    if (dataSelected && Object.keys(dataSelected).length > 0) {
      getAllSinisterByContract({
        variables: { idContract: dataSelected.contrato_id },
      });
    }
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [dataSelected]);
  return (
    <ModuleContainer open={!isBlockedSiniester}>
      <Header>
        {/* <IconWrapper>
          <EditPencilIcon />
        </IconWrapper> */}
        <ModuleTitle>Número de Siniestro: </ModuleTitle>
        <SelectWrapper>
          <ReactSelect
            ref={siniestroRef}
            options={options}
            onChange={(choice) => selectedSinester(choice)}
            placeholder="#00000"
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderRadius: "8px",
                height: "32px",
              }),
            }}
          />
        </SelectWrapper>

        <IconWrapper
          onClick={() => {
            onButton();
          }}
        >
          {" "}
          <ArrowDownIcon className="arrow" />
        </IconWrapper>
      </Header>

      <Divider />
      <Content className="content">
        <General
          getAllRemiderByIdSinester={getAllRemiderByIdSinester}
          contract={dataSelected}
          sinester={dataSinester}
          remider={dataRemider}
          documentSinester={dataDocumentsSinester}
          documentRemider={documentsRemider}
          open={open}
          setOpen={setOpen}
        />
        <div ref={generalRef}></div>
        <AgregarMovimientos
          contract={contractState}
          setMovementOpen={setOpenMovements}
          movementOpen={openMovements}
        />
      </Content>
    </ModuleContainer>
  );
};

const ModuleContainer = styled.div`
  border-radius: 24px;
  width: 1200px;
  display: flex;
  flex-direction: column;
  transition: 300ms;
  margin-top: 40px;
  margin-bottom: 80px;
  @media only screen and (max-width: 1280px) {
    width: 90vw;
  }
  //Divider
  & > .content {
    display: ${(props) => (props.open ? "block" : "none")};
  }
  & .arrow {
    transition: 500ms;
    transform: ${(props) => (props.open ? "rotate(180deg)" : "rotate(0deg)")};
  }
`;

const Header = styled.div`
  cursor: pointer;
  display: flex;

  justify-content: space-between;
  align-items: center;
  //gap: 16px;

  @media only screen and (max-width: 1280px) {
    padding: 0 12px;
  }
`;

const ModuleTitle = styled.div`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
  flex: 1;
  display: flex;
  align-items: center;
  //gap: 12px;
  min-width: fit-content;
  padding-right: 15px;
  @media only screen and (max-width: 426px) {
    display: none;
  }
  @media only screen and (max-width: 1280px) {
    gap: 0;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Content = styled.div``;

const IconWrapper = styled.div`
  padding: 6px 6px 6px 15px;
`;

const SelectWrapper = styled.div`
  font-size: 16px;
  margin-top: 4px;
  width: 100%;
  @media only screen and (max-width: 1280px) {
    width: 100%;
    margin-top: 12px;
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  margin: 24px 0;
  background-color: var(--primary-pistachio);
`;
